/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  findMessages,
  FIND_MESSAGES_SUCCESS,
  sendMessage,
  SEND_MESSAGE_SUCCESS,
} from '../../../store/actions/customer-actions';
import { INBOUND } from '../../../utils/enumerator/enum-message-type';
import styles from './styles.module.scss';

function WebChat({ findMessages, sendMessage }) {
  const [messageToSend, setMessageToSend] = useState('');
  const [messages, setMessages] = useState([]);
  const [intervalId, setIntervalId] = useState(0);
  const [openChatTime, setOpenChatTime] = useState(null);
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (openChatTime === 0) {
      closeChat();
      return;
    }

    const interval = setInterval(() => {
      openChatTime > 0 && setOpenChatTime(openChatTime - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [openChatTime]);

  const openChat = () => {
    setOpened(!opened);

    if (opened) {
      setOpenChatTime(0);

      if (intervalId > 0) {
        clearInterval(intervalId);
        setIntervalId(0);
      }
    } else {
      setOpenChatTime(600);

      if (intervalId === 0) {
        findChatMessages();
        const intervalIdentification = setInterval(() => {
          findChatMessages();
        }, 5000);

        setIntervalId(intervalIdentification);
      }
    }
  };

  const closeChat = () => {
    if (intervalId !== 0) {
      clearInterval(intervalId);
      setIntervalId(0);
      setOpened(false);
    }
  };

  const onSendMessageClick = async () => {
    if (messageToSend !== undefined && messageToSend !== null && messageToSend !== '') {
      const response = await sendMessage(messageToSend);
      if (response.type === SEND_MESSAGE_SUCCESS) {
        setMessages(response.payload);
        setMessageToSend('');
      }
    }
  };

  const findChatMessages = async () => {
    const response = await findMessages();
    if (response.type === FIND_MESSAGES_SUCCESS) {
      setMessages(response.payload);
    }
  };

  const onMessageToSendChange = (e) => {
    setMessageToSend(e.target.value);
  };

  const handleKeypress = (e) => {
    if (e.which === 13) {
      onSendMessageClick();
      setMessageToSend('');
    }
  };

  return (
    <>
      {opened && (
        <div className={styles.webchatWrapper}>
          <span id="webchat_popup">
            <a className={styles.webchatPopupClose} onClick={closeChat} id="webchat_popup__close" title="Minimizar" />
          </span>

          <div id="chatbox__container">
            <div className={`${styles.chatboxSupport} ${styles.chatboxActive}`}>
              <div className={styles.chatboxHeader}>
                <div className={styles.chatboxContentHeader}>
                  <img
                    className={styles.chatboxImageHeader}
                    src="/image/chat_assistente.png"
                    alt="Atendente Supersim"
                  />

                  <h4 className={styles.chatboxHeadingHeader}>
                    Jaqueline - Supersim
                    <br />
                    <small>Online agora</small>
                  </h4>
                </div>
              </div>

              <div className={styles.chatboxMessages}>
                {messages &&
                  messages.length > 0 &&
                  messages.map(
                    (message) =>
                      message.content !== null &&
                      message.content !== undefined &&
                      message.content !== '' &&
                      (message.direction === INBOUND ? (
                        <div key={message.id} className={`${styles.messagesItem} ${styles.messagesItemVisitor}`}>
                          {message.content}
                        </div>
                      ) : (
                        <div key={message.id} className={`${styles.messagesItem} ${styles.messagesItemOperator}`}>
                          <span dangerouslySetInnerHTML={{ __html: message.content }} />
                        </div>
                      )),
                  )}
                <div key={123321} className={`${styles.messagesItem} ${styles.messagesItemOperator}`}>
                  Olá :) Escreva algo para iniciar.
                </div>
              </div>

              <div className={styles.chatboxFooter}>
                <div className={styles.chatboxFooterContainer}>
                  <input
                    id="visitorQuestion"
                    onChange={onMessageToSendChange}
                    value={messageToSend}
                    name="visitorQuestion"
                    type="text"
                    placeholder="Escreva aqui..."
                    onKeyPress={(e) => {
                      handleKeypress(e);
                    }}
                  />
                  <button onClick={onSendMessageClick} className={styles.chatboxSendFooterButton} type="button">
                    <img src="/image/btn_send_arrow.png" alt="Enviar Resposta" width={30} height={30} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <a href="#chatbox__container" className={styles.chatboxLauncher}>
        <div id="webchat_launcher_icon" onClick={openChat}>
          <img id="closed" src="/image/btn_fab_assistente.png" alt="" />
        </div>
      </a>
    </>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  findMessages: () => dispatch(findMessages()),
  sendMessage: (message) => dispatch(sendMessage(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebChat);
